import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  EParamInventoryTypeGlobal,
  ETimeBucketType,
  IReportingAdGroupsChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsPositionsReportChartFilters,
  TDAAdGroupsReportChartFilters,
  TDOOHAdGroupsReportChartFilters,
  TDOOHAdGroupsScreensReportChartFilters,
  TGenericAdGroupsCategoriesReportChartFilters,
  TGenericAdGroupsKeywordsReportChartFilters,
  TGenericAdGroupsReportChartFilters,
  TPPAdvertiserId,
  TSPAdGroupsReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingAdGroupsChartV3({
  advertiserId,
  retailerId,
  inventoryType,
  campaignId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TGenericAdGroupsReportChartFilters
  | TGenericAdGroupsCategoriesReportChartFilters
  | TGenericAdGroupsKeywordsReportChartFilters
  | TSPAdGroupsReportChartFilters
  | TDAAdGroupsReportChartFilters
  | TDAAdGroupsPositionsReportChartFilters
  | TDOOHAdGroupsReportChartFilters
  | TDOOHAdGroupsScreensReportChartFilters
) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingAdGroupsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingAdGroupsChart_${inventoryType}_${advertiserId}_${retailerId}`

  return useQuery(
    [
      queryKeyName,
      { start: startDate, end: endDate, inventoryType, campaignId },
    ],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserAdGroupsReportChartV3(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        inventoryType as EParamInventoryTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
